import React from 'react';
import './TabComponent.css';

const TabComponent = ({ activeTab, setActiveTab }) => {
    const tabs = [
        { id: 'Overall', label: 'Overall' },
        { id: 'Weekly', label: 'Weekly' },
        { id: 'Monthly', label: 'Monthly' },
        { id: 'Yearly', label: 'Yearly' },
    ];

    return (
        <div className="tab-container">
            <div role="tablist" aria-orientation="vertical" className="tab-list">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        aria-controls={`tab-content-${tab.id}`}
                        data-state={activeTab === tab.id ? 'active' : 'inactive'}
                        id={`tab-trigger-${tab.id}`}
                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TabComponent;